import { SortOrderEnum } from '@workalizer/shared';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { useState } from 'react';
export function useWidgetTableSort(defaultField, defaultDirection) {
    if (defaultDirection === void 0) { defaultDirection = SortOrderEnum.DESC; }
    var _a = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _a[0], setDisplayedCount = _a[1];
    var _b = useState({
        field: defaultField,
        direction: defaultDirection
    }), sortBy = _b[0], setSortBy = _b[1];
    var handleSortChange = function (option) {
        setSortBy({
            field: option.orderByField,
            direction: option.direction
        });
        setDisplayedCount(WIDGET_TABLE_INITIAL_ROWS);
    };
    var loadMore = function () {
        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
    };
    return {
        sortBy: sortBy,
        displayedCount: displayedCount,
        handleSortChange: handleSortChange,
        loadMore: loadMore
    };
}
